import React, { useEffect, useRef, useState } from "react";
import { X, Wand2 } from "lucide-react";
import { setNewClient, setShowWizard } from "../../../store/slices/WizardSlice/WizardSlice";
import { useDispatch, useSelector } from "react-redux";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { useSnackbar } from "notistack";
import { uploadFile } from "../../../store/slices/FileDataSlice";
import WizardFileUpload from "./WizardFileUpload";
import { fetchLeadTypes } from "../../../store/slices/leadTypeSlice";
import { fetchGroups } from "../../../store/slices/groupSlice";
import { fetchSources } from "../../../store/slices/sourceSlice";
import { fetchStatus } from "../../../store/slices/statusSlice";
import { fetchEmployees } from "../../../store/slices/employeeAdminSlice";
import { addLead } from "../../../store/slices/leadsSlice";
import {
  isWonLeadStatusValue,
  withDirectWonCommentMarker,
} from "../../../utils/isDirectWonLead";
import PhoneInput from "react-phone-input-2";
import AdminLoader from "../../../components/common/loader/AdminLoader";
import Chip from '@mui/material/Chip';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchEmployeeGroups } from "../../../store/slices/employeeGroup";
import { createProjectRequest } from "../../../store/slices/managerProjectRequestedSlice";
import DateConversion from "../../../utils/DateConversion";
import { resolveCountryInputConfig, useCurrencySymbol } from "../../../utils/currencyUtils";
import CommaConvert from "../../../utils/CommaConvert";
import { useLoggedUser } from "../../../utils/useLoggedUser";


const parseFormattedNumber = (formattedValue) => {
    // Remove commas to get the raw numeric value
    return formattedValue.replace(/,/g, '');
};


const NewClient = ({ setshowWizard }) => {

    const { getDatePlaceholder, getDateFormat } = DateConversion();
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();


    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [step, setStep] = useState(1);
    const totalSteps = 4;
    const [resources, setResources] = useState([]);
    const [empGroups, setEmpGroups] = useState([]);
    const [leadTypes, setLeadTypes] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

    const LeadProbablilityAll = [
        { label: "High" },
        { label: "Medium" },
        { label: "Low" },
    ];


    const { employees } = useSelector((state) => state.employees);
    const { group } = useSelector((state) => state.group);
    const { source } = useSelector((state) => state.source);
    const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux);
    const { status } = useSelector((state) => state.status);
    const auth = localStorage.getItem("auth");

    useEffect(() => {
        dispatch(fetchLeadTypes());
        dispatch(fetchGroups());
        dispatch(fetchSources());
        dispatch(fetchStatus());
        dispatch(fetchEmployees());
    }, [dispatch]);

    const loggedEmployee = useLoggedUser();

    useEffect(() => {
        const empGroup = group.filter((grp) =>
            loggedEmployee?.EmpGroups?.includes(grp?.newGroupName)
        );
        setEmpGroups(empGroup);
    }, [group, loggedEmployee])

    useEffect(() => {
        if (status?.length > 0) {
            setStatusList(status);
        }
        if (leadTypesRedux?.length > 0) {
            setLeadTypes(leadTypesRedux);
        }
        if (source?.length > 0) {
            setResources(source);
        }
    }, [source, status, leadTypesRedux]);

    const handleNext = () => {
        if (step < totalSteps) setStep(step + 1);
    };

    const handlePrev = () => {
        if (step > 1) setStep(step - 1);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const today = new Date();
    const [isLoading, SetisLoading] = useState(false);
    const [selectedProjectName, setSelectedProjectName] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedSource, setSelectedSource] = useState(null);
    const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
    const [selectedLeadType, setSelectedLeadType] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedProbability, setSelectedProbability] = useState(null);
    const [selectedQuotedValue, setSelectedQuotedValue] = useState(null);
    const [LeadDate, setLeadDate] = useState(today);
    const [clientName, setClientName] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [selectedEmail, setSelectedEmail] = useState("");
    const [ClientPhone, setClientPhone] = useState("");
    const [selectedFollowupDate, setSelectedFollowupDate] = useState(null);
    const [selectedReference, setSelectedReference] = useState(null);
    const [assignedPeopleList, setAssignedPeopleList] = useState([]);
    const [employeesfinalList, setEmployeesfinalList] = useState([]);
    const [selectedPrimaryResourceList, setSelectedPrimaryResourceList] = useState(null);
    const [filteredGroupsManager, setFilteredGroupsManager] = useState([]);
    const { groups } = useSelector((state) => state.employeeGroup);

    useEffect(() => {
        dispatch(fetchEmployeeGroups());
    }, [dispatch]);
    useEffect(() => {
        const email = localStorage.getItem("email"); // Make sure this is set in localStorage

        if (groups && groups.length > 0 && email) {
            const matchedGroups = groups.filter(
                (group) => group.createdBy?.EmpEmail === email
            );
            setFilteredGroupsManager(matchedGroups);
        }
    }, [groups]);
    useEffect(() => {
        setEmployeesfinalList(filteredGroupsManager);
    }, [filteredGroupsManager]);
    const handleProjectNameChange = (e) => {
        setSelectedProjectName(e.target.value);
    };

    const handleClientNameChange = (e) => {
        setClientName(e.target.value);
    };

    const handleContactPersonChange = (e) => {
        setContactPerson(e.target.value);
    }

    const handleEmailChange = (e) => {
        setSelectedEmail(e.target.value);
    }
    const handleReferenceChange = (e) => {
        setSelectedReference(e.target.value);
    }

    const [fileRefValue, setFileRef] = useState();
    const dropdownRef = useRef(null);


    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !event.target.closest('.dropdown-container') // Add this line
            ) {
                setOpenDropdownIndex(null);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const autoCompleteStyles = {
        width: "100%",
        "& .MuiInputBase-root": {
            padding: "2px 6px",     // reduce internal padding
            height: 45,             // control height
            borderRadius: 2,        // border radius
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#c4c4c4", // normal border
            },
            "&:hover fieldset": {
                borderColor: "#000",    // hover border
            },
            "&.Mui-focused fieldset": {
                borderColor: "#1976d2", // focus border
            },
        },
        "& .MuiAutocomplete-listbox": {
            padding: 0,             // remove extra vertical padding
        },

        "& .MuiAutocomplete-option": {
            fontSize: "10px",       // reduce dropdown text size
            padding: "4px 4px",     // reduce vertical spacing
            minHeight: "24px",      // set fixed option height (optional)
        },
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // const getMissingFields = () => {
    //     const missing = [];

    //     if (!clientName) missing.push("Client Name");
    //     if (!ClientPhone) missing.push("Client Phone");
    //     if (!contactPerson) missing.push("Contact Person");
    //     if (!selectedSource?.newSource) missing.push("Source");
    //     if (!selectedServiceType) missing.push("Service Type");
    //     if (!selectedQuotedValue) missing.push("Quoted Value");

    //     if (selectedStatus?.status === "Pending" &&
    //         !["High", "Medium", "Low"].includes(selectedProbability?.label)
    //     ) {
    //         missing.push("Probability");
    //     }
    //     if (!LeadDate) missing.push("Lead Date");

    //     if (selectedStatus?.status !== "Won" && selectedStatus?.status !== "Lost") {
    //         if (!selectedFollowupDate) missing.push("Follow-up Date");
    //     }
    //     return missing;
    // };


    const getMissingFields = () => {
        const missing = [];

        if (!clientName) missing.push("Client Name");
        if (!ClientPhone) missing.push("Client Phone");
        if (!contactPerson) missing.push("Contact Person");
        if (!selectedSource?.newSource) missing.push("Source");
        if (selectedServiceTypes.length === 0) missing.push("Service Type"); // Updated this line
        if (!selectedQuotedValue) missing.push("Quoted Value");

        if (selectedStatus?.status === "Pending" &&
            !["High", "Medium", "Low"].includes(selectedProbability?.label)
        ) {
            missing.push("Probability");
        }
        if (!LeadDate) missing.push("Lead Date");

        if (selectedStatus?.status !== "Won" && selectedStatus?.status !== "Lost") {
            if (!selectedFollowupDate) missing.push("Follow-up Date");
        }
        return missing;
    };

    const handleProjectSubmit = async (e) => {
        e.preventDefault();
        const missingFields = getMissingFields();

        if (missingFields.length > 0) {
            enqueueSnackbar(
                `Please fill: ${missingFields.join(", ")}`,
                { variant: "error" }
            );
            return;
        }

        const lastTenDigits = ClientPhone.slice(-10);
        if (/^0{10}$/.test(lastTenDigits)) {
            enqueueSnackbar("Enter Valid Phone Number!", {
                variant: "error",
            });
            return;
        }
        const numericPhone = ClientPhone.replace(/\D/g, ""); // Removes non-numeric characters
        if (numericPhone.length < 10) {
            enqueueSnackbar("Phone number must be at least 10 digits!", {
                variant: "error",
            });
            return;
        }

        if (!emailRegex.test(selectedEmail)) {
            enqueueSnackbar("Please enter a valid email address!", {
                variant: "error",
            });
            return;
        }

        if (selectedSource === "Reference" && !selectedReference) {
            enqueueSnackbar("Please enter Reference!", {
                variant: "error",
            });
            return;
        }

        SetisLoading(true);
        try {
            // const newLead = {
            //     ClientName: clientName,
            //     ClientEmail: selectedEmail,
            //     ProjectName: selectedProjectName,
            //     LeadDate: LeadDate,
            //     ClientPhone: ClientPhone,
            //     QuotedValue: selectedQuotedValue,
            //     ClientContactName: contactPerson,
            //     Status: selectedStatus?.status,
            //     Source: selectedSource?.newSource,
            //     TypeService: selectedServiceType,
            //     AssignedGroup: selectedGroup?.newGroupName,
            //     LeadType: selectedLeadType?.LeadType,
            //     FollowupDate: selectedFollowupDate,
            //     Probability: selectedProbability?.label,
            //     Reference: selectedReference ? selectedReference : "",
            //     SalesPersonStatus: "project requested",
            // };

            const newLead = {
                ClientName: clientName,
                ClientEmail: selectedEmail,
                ProjectName: selectedProjectName,
                LeadDate: LeadDate,
                ClientPhone: ClientPhone,
                QuotedValue: selectedQuotedValue,
                ClientContactName: contactPerson,
                Status: selectedStatus?.status,
                Source: selectedSource?.newSource,
                TypeService: selectedServiceTypes, // Updated this line - now an array
                AssignedGroup: selectedGroup?.newGroupName,
                LeadType: selectedLeadType?.LeadType,
                FollowupDate: selectedFollowupDate,
                Probability: selectedProbability?.label,
                Reference: selectedReference ? selectedReference : "",
                SalesPersonStatus: "project requested",
                ...(isWonLeadStatusValue(selectedStatus?.status)
                  ? {
                      isDirectWon: true,
                      comments: withDirectWonCommentMarker(""),
                    }
                  : {}),
            };
            const response = await dispatch(addLead(newLead)).unwrap();
            enqueueSnackbar("Lead Added Successfully!", {
                variant: "success",
            });
            const data = response.lead;
            //   await handleFileUpload(data._id); 
            await handleFileUpload(fileRefValue, data._id);
            await handleFilemanagerforward(data)
            dispatch(setNewClient(false))
            dispatch(setShowWizard(false))
        } catch (error) {
            console.error("Error:", error);
            const errorMessage =
                error?.error || // For rejectWithValue
                error?.response?.data?.error || // Fallback for direct axios
                error?.message ||
                "Something went wrong. Please try again.";
            enqueueSnackbar(errorMessage, {
                variant: "error",
            });
        } finally {
            SetisLoading(false);

        }
    };


    const [fileNames, setFileNames] = useState([]);
    const [SelectedCategory, setSelectedCategory] = useState("");
    const [, setCurrentFileName] = useState("No File Selected");


    const handleFileUpload = async (event, id, Category) => {
        if (!fileNames.length) {
            return;
        }
        const uploadDate = new Date().toISOString().slice(0, 10); // "2024-07-11"
        const formData = new FormData();

        // Append the common fields
        formData.append("leadId", id);
        formData.append("uploadDate", uploadDate);

        // Append each category and file separately
        fileNames.forEach((file) => {
            formData.append("selectedCategory", file.selectedCategory);
            formData.append("files", file);
        });

        setFileRef(event);

        try {
            await dispatch(uploadFile(formData)).unwrap(); // Use Redux thunk
            setCurrentFileName("");
        } catch (error) {
            enqueueSnackbar("Error occurred while uploading file", {
                variant: "error",
            });
            console.error("Error uploading file:", error);
        }
    };

    const handleFilemanagerforward = async (data) => {
        const selectedRow = data;
        const email = localStorage.getItem("email");
        const firstname = localStorage.getItem("name");
        const lastname = localStorage.getItem("lastName");
        const name = firstname + " " + lastname

        const peopleAtIndex = assignedPeopleList || [];

        const TypeServiceMap = peopleAtIndex.reduce((map, person) => {
            const match = employees.find((emp) => {
                const fullName =
                    `${emp.EmpFirstName?.trim()} ${emp.EmpLastName?.trim()}`.toLowerCase();
                const personName = person.name?.trim().toLowerCase();
                return emp.EmpEmail === person.email || fullName === personName;
            });

            if (match && match.servicetype) {
                map[person.email] = match.servicetype;
            }

            return map;
        }, {});

        const projects = [
            {
                AssignedGroup: selectedRow.AssignedGroup,
                PrimaryResources: selectedPrimaryResourceList, // Check if any primary resource is assigned
                AssignedManagerEmail: peopleAtIndex.map((person) => person.email), // array of email
                TypeServiceMap: TypeServiceMap,
                ClientContactName: selectedRow.ClientContactName,
                ClientEmail: selectedRow.ClientEmail,
                ClientName: selectedRow.ClientName,
                ClientPhone: selectedRow.ClientPhone,
                // ProjectDueDate: selectedRow.DateDue
                //     ? new Date(selectedRow.DateDue).toISOString()
                //     : null,
                ProjectDueDate: selectedRow.FollowupDate
                    ? new Date(new Date(selectedRow.FollowupDate).getTime() + (7 * 24 * 60 * 60 * 1000)).toISOString()
                    : null,
                DateRequested: selectedRow.LeadDate,
                FollowupDate: selectedRow.FollowupDate,
                LeadDate: selectedRow.LeadDate,
                LeadOwner: name,
                LeadOwnerEmail: email,
                LeadType: selectedRow.LeadType,
                ProjectName: selectedRow.ProjectName,
                quotationId: selectedRow.quotationId,
                QuotedValue: selectedRow.QuotedValue,
                SalesPersonStatus: selectedRow.SalesPersonStatus,
                Source: selectedRow.Source,
                Status: selectedRow.Status,
                SalesPersonEmail: selectedRow.email,
                SalesPersonName: name,
            },
        ];

        const formData = new FormData();
        formData.append("projects", JSON.stringify(projects));

        // 1. Get files and their categories (assuming `fileNames` contains `selectedCategory`)
        const files = fileNames[selectedRow.ProjectName] || [];
        const categories = files.map((file) => file.selectedCategory);

        // 2. Append ALL FILES first (in order)
        files.forEach((file) => {
            formData.append("files", file); // Just the File object
        });

        // 3. Append ALL CATEGORIES next (in the SAME order)
        categories.forEach((category) => {
            formData.append("selectedCategory", category);
        });

        try {
            await dispatch(createProjectRequest(formData)).unwrap();
            enqueueSnackbar("Project Forwarded Successfully", {
                variant: "success",
            }); setCurrentFileName("");
        } catch (error) {
            enqueueSnackbar("Error occurred while forwarding to manager", {
                variant: "error",
            });
        }
    };

    const [formattedValue, setFormattedValue] = useState("");
    const handleQuotedValueChange = (e) => {
        const rawValue = parseFormattedNumber(e.target.value);
        setSelectedQuotedValue(rawValue);
        setFormattedValue(USAComma(rawValue));
    };

    const { iso2: defaultCountry, onlyCountries: allowedCountries } =
        resolveCountryInputConfig({
            countrycode: loggedEmployee?.countrycode,
            region: loggedEmployee?.region,
        });

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-white z-[1400]">

            {/* <div className="fixed inset-0 flex justify-center items-center bg-black/30 z-[1400]"> */}
            {isLoading ? (
                <AdminLoader isLoading={isLoading} />
            ) : (<></>)}
            <div className="w-[30%] rounded-2xl shadow-lg bg-gradient-to-b from-blue-500 to-blue-400 text-white p-4 relative font-sans">
                <div>
                    <div className="flex">
                        <div className="">
                            <button
                                onClick={() => {
                                    dispatch(setNewClient(false));
                                    setshowWizard(true)
                                }}
                                className="absolute top-5 right-4 hover:text-white cursor-pointer">
                                <X size={18} />
                            </button>
                        </div>

                        <div className="flex items-center gap-2 mb-4">
                            <Wand2 size={20} />
                            <h2 className="font-semibold text-lg">Wizard</h2>
                        </div>
                    </div>

                    <div className="w-full bg-white/30 h-2 rounded-full mb-3">
                        <div
                            className="bg-white h-2 rounded-full transition-all duration-300"
                            style={{ width: `${(step / totalSteps) * 100}%` }}
                        ></div>
                    </div>
                    <p className="text-start text-sm mb-4 text-white/90">
                        Step {step} of {totalSteps}
                    </p>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className="bg-white text-gray-800 p-4 rounded-xl shadow-inner space-y-3"
                >
                    {step === 1 && (
                        <>
                            <h3 className="font-semibold text-base mb-2">
                                Client Information
                            </h3>
                            <div>
                                <label className="text-sm font-medium">Client Name</label>
                                <input
                                    name="clientName"
                                    value={clientName}
                                    onChange={handleClientNameChange}
                                    placeholder="Enter Client Name"
                                    className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium">Contact Person</label>
                                <input
                                    name="contactPerson"
                                    value={contactPerson}
                                    onChange={handleContactPersonChange}
                                    placeholder="Enter Contact Person"
                                    className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Email ID</label>
                                <input
                                    name="email"
                                    value={selectedEmail}
                                    onChange={handleEmailChange}
                                    placeholder="Enter Email"
                                    className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Mobile Number</label>
                                {/* <PhoneInput
                                    country={"us"}
                                    value={String(ClientPhone)}
                                    onChange={(value) => setClientPhone(value)}
                                    enableSearch={true}
                                    inputProps={{
                                        required: true,
                                        className:
                                            "w-full h-9 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-14",
                                        style: {
                                            fontFamily:
                                                "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                                        },
                                    }}
                                /> */}
                                <PhoneInput
                                    country={defaultCountry}
                                    value={String(ClientPhone)}
                                    disableDropdown={true}
                                    onChange={(value) => setClientPhone(value)}
                                    enableSearch={true}
                                    onlyCountries={allowedCountries}
                                    preferredCountries={[]}       // <-- Required to remove default countries
                                    dropdownStyle={{
                                        position: 'absolute',
                                        bottom: '100%',
                                        marginBottom: '5px',
                                        zIndex: 9999,
                                    }}
                                    inputProps={{
                                        required: true,
                                        className: "w-full h-9 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-14",
                                        style: {
                                            fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                                        },
                                    }}
                                />
                            </div>

                        </>
                    )}

                    {step === 2 && (
                        <div>
                            <h3 className="font-semibold mb-2 text-base">
                                Lead Source & Project Details
                            </h3>
                            <div>
                                <label className="text-sm font-medium">Source</label>
                                <Autocomplete
                                    disablePortal

                                    options={resources}
                                    getOptionLabel={(option) => option.newSource || ""}
                                    value={selectedSource}
                                    onChange={(event, value) => setSelectedSource(value)}
                                    sx={autoCompleteStyles}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Source"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "15px", padding: "0 !important" },
                                            }}

                                        />
                                    )}
                                />
                            </div>
                            {selectedSource?.newSource === "Reference" && (
                                <div>
                                    <label className="text-sm font-medium"> Reference</label>
                                    <input
                                        name="contactPerson"
                                        value={selectedReference}
                                        onChange={handleReferenceChange}
                                        placeholder="Enter Contact Person"
                                        className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm  focus:ring-2 focus:ring-blue-400 outline-none"
                                    />
                                </div>
                            )}


                            <div>
                                <label className="text-sm font-medium">Group</label>
                                {/* <Autocomplete
                                    disablePortal
                                    options={empGroups}
                                    sx={autoCompleteStyles}
                                    value={selectedGroup}
                                    getOptionLabel={(option) => option.newGroupName || ""}
                                    onChange={(event, value) => {
                                        setSelectedGroup(value);
                                        if (value === null || undefined || !selectedGroup) {
                                            setSelectedServiceTypes(null);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Group"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "12px", padding: "0 !important" },
                                            }}
                                            InputLabelProps={{
                                                sx: { fontSize: "12px" },
                                            }}
                                        />
                                    )}
                                /> */}
                                <Autocomplete
                                    disablePortal
                                    options={empGroups}
                                    sx={autoCompleteStyles}
                                    value={selectedGroup}
                                    getOptionLabel={(option) => option.newGroupName || ""}
                                    onChange={(event, value) => {
                                        setSelectedGroup(value);
                                        // Clear selected services when group changes
                                        setSelectedServiceTypes([]);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Group"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "15px", padding: "0 !important" },
                                            }}
                                            InputLabelProps={{
                                                sx: { fontSize: "15px" },
                                            }}
                                        />
                                    )}
                                />
                            </div>

                            {/* <div>
                                <label className="text-sm font-medium">Type Of Service</label>
                                <Autocomplete
                                    disablePortal
                                    options={selectedGroup?.servicetype}
                                    getOptionLabel={(option) => option}
                                    value={selectedServiceType}
                                    disabled={!selectedGroup || (selectedGroup?.servicetype?.length === 0)}
                                    onChange={(event, value) => setSelectedServiceType(value)}
                                    sx={autoCompleteStyles}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Service"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "12px", padding: "0 !important" },
                                            }}
                                            InputLabelProps={{
                                                sx: { fontSize: "12px" },
                                            }}
                                        />
                                    )}
                                />
                            </div> */}

                            <div>
                                <label className="text-sm font-medium">Type Of Service</label>
                                <Autocomplete
                                    multiple // Enable multiple selection
                                    disableCloseOnSelect
                                    disablePortal
                                    options={selectedGroup?.servicetype || []}
                                    getOptionLabel={(option) => option}
                                    value={selectedServiceTypes}
                                    disabled={!selectedGroup || (selectedGroup?.servicetype?.length === 0)}
                                    onChange={(event, value) => setSelectedServiceTypes(value)}
                                    sx={{
                                        ...autoCompleteStyles,
                                        "& .MuiChip-root": {
                                            height: "24px",
                                            "& .MuiChip-label": {
                                                fontSize: "10px",
                                                padding: "0 8px",
                                            },
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Services"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "15px", padding: "0 !important" },
                                            }}
                                            InputLabelProps={{
                                                sx: { fontSize: "15px" },
                                            }}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option}
                                                size="small"
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Project Name</label>
                                <input
                                    name="contactPerson"
                                    value={selectedProjectName}
                                    onChange={handleProjectNameChange}
                                    placeholder="Enter Projectname"
                                    className="w-full border border-gray-400 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                />
                            </div>
                        </div>
                    )}

                    {step === 3 && (
                        <div>
                            <h3 className="font-semibold mb-2 text-base">
                                Financials & Lead Metrics
                            </h3>
                            <div>
                                <label className="text-sm font-medium">Quoted Value</label> ({currency})
                                <input
                                    name="text"
                                    // value={selectedQuotedValue}
                                    // onChange={(e) => setSelectedQuotedValue(e.target.value)}
                                    value={formattedValue}
                                    onChange={handleQuotedValueChange}
                                    placeholder="Select Source"
                                    className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium">Lead Type</label>
                                <Autocomplete
                                    disablePortal
                                    options={leadTypes}
                                    value={selectedLeadType}
                                    getOptionLabel={(option) => option.LeadType || ""}
                                    onChange={(event, value) => setSelectedLeadType(value)}
                                    sx={autoCompleteStyles}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Lead Type"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "15px", padding: "0 !important" },
                                            }}
                                            InputLabelProps={{
                                                sx: { fontSize: "15px" },
                                            }}
                                        />
                                    )}
                                />
                            </div>

                            <div>
                                <label className="text-sm font-medium">Status</label>
                                <Autocomplete
                                    disablePortal
                                    options={statusList}
                                    value={selectedStatus}
                                    getOptionLabel={(option) => option.status || ""}
                                    onChange={(event, value) => setSelectedStatus(value)}
                                    sx={autoCompleteStyles}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Status"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { fontSize: "15px", padding: "0 !important" },
                                            }}
                                            InputLabelProps={{
                                                sx: { fontSize: "15px" },
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            {selectedStatus?.status === "Pending" && (
                                <div>
                                    <label className="text-sm font-medium">Probability</label>
                                    <Autocomplete
                                        disablePortal
                                        options={LeadProbablilityAll}
                                        value={selectedProbability}
                                        onChange={(event, value) => setSelectedProbability(value)}
                                        sx={autoCompleteStyles}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select Probability"
                                                variant="outlined"
                                                size="small"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    sx: { fontSize: "15px", padding: "0 !important" },
                                                }}
                                                InputLabelProps={{
                                                    sx: { fontSize: "15px" },
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            )}

                        </div>
                    )}

                    {step === 4 && (
                        <div>
                            <div className="flex flex-col pb-2">
                                <label className="text-sm font-medium">
                                    Lead Date
                                </label>
                                <DatePicker
                                    maxDate={new Date()}
                                    selected={LeadDate}
                                    onChange={(date) => setLeadDate(date)}
                                    placeholderText={getDatePlaceholder()}
                                    className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                    dateFormat={getDateFormat()}
                                />

                            </div>
                            {(selectedStatus?.status === "Pending" || selectedStatus?.status === "Won Recurring") && (
                                <div className="flex flex-col pb-2">
                                    <label className="text-sm font-medium">
                                        Next Follow-Up Date
                                    </label>
                                    <DatePicker
                                        minDate={
                                            LeadDate
                                                ? new Date(
                                                    new Date(LeadDate).setDate(
                                                        new Date(LeadDate).getDate() + 1
                                                    )
                                                )
                                                : null
                                        }
                                        selected={selectedFollowupDate}
                                        onChange={(date) => setSelectedFollowupDate(date)}
                                        placeholderText={getDatePlaceholder()}
                                        className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                                        dateFormat={getDateFormat()}
                                    />
                                </div>
                            )}


                            {auth === "L3" && (
                                <>
                                    {(selectedStatus?.status === "Won" || selectedStatus?.status === "Won Recurring" || selectedStatus?.status === "Pending") && (
                                        <div className="flex flex-col pb-2">
                                            <label className="text-sm font-medium">
                                                Select Resources
                                            </label>
                                            <div className="flex w-full flex-shrink-0  pt-1 justify-center align-middle items-center">
                                                <div ref={dropdownRef} className="dropdown-container w-full rounded-md relative flex justify-center text-xs align-middle items-center border border-gray-300">
                                                    <button
                                                        onClick={() => {
                                                            setOpenDropdownIndex(
                                                                !openDropdownIndex
                                                            );
                                                        }}
                                                        className="w-full text-xs px-2 py-2 truncate flex justify-between items-center"
                                                    >
                                                        {assignedPeopleList?.length >
                                                            0
                                                            ? assignedPeopleList
                                                                .map((item) => item.name)
                                                                .join(", ")
                                                            : "Resources"}
                                                    </button>

                                                    <ExpandMoreIcon
                                                        onClick={() =>
                                                            setOpenDropdownIndex(
                                                                !openDropdownIndex

                                                            )
                                                        }
                                                        className="ml-1 absolute right-0 cursor-pointer bg-white group-hover:bg-gray-100"
                                                    />

                                                    {openDropdownIndex && (
                                                        <div className="absolute top-full left-0  max-w-26 max-h-52 overflow-y-auto bg-white border border-gray-300 shadow-lg z-50 narrow-scrollbar">
                                                            {employeesfinalList.filter(
                                                                (emp) =>
                                                                    emp.groupId?.newGroupName === selectedGroup?.newGroupName &&
                                                                    selectedServiceTypes?.includes(emp.employeeId?.servicetype)
                                                            ).length > 0 ? (
                                                                employeesfinalList
                                                                    .filter(
                                                                        (emp) =>
                                                                            emp.groupId?.newGroupName === selectedGroup?.newGroupName &&
                                                                            selectedServiceTypes?.includes(emp.employeeId?.servicetype)
                                                                    )
                                                                    .map((emp) => {
                                                                        const fullName = `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`;
                                                                        const empEmail = emp.employeeId?.EmpEmail;
                                                                        const isAssigned = assignedPeopleList?.some(
                                                                            (item) => item.email === empEmail
                                                                        );

                                                                        return (
                                                                            <label
                                                                                key={emp.employeeId?.id || emp.employeeId?._id}
                                                                                className="flex justify-between align-middle items-center px-2 py-1 bg-white hover:bg-gray-100 text-xs"
                                                                            >
                                                                                <input
                                                                                    title="Select Resources"
                                                                                    type="checkbox"
                                                                                    className="mr-2"
                                                                                    value={fullName}
                                                                                    checked={isAssigned || false}
                                                                                    onChange={(e) => {
                                                                                        const selectedValue = {
                                                                                            name: fullName,
                                                                                            email: empEmail,
                                                                                        };
                                                                                        const isChecked = e.target.checked;
                                                                                        setAssignedPeopleList((prev) => {
                                                                                            const current = prev || [];
                                                                                            if (isChecked) {
                                                                                                const alreadyExists = current.some(
                                                                                                    (item) => item.email === selectedValue.email
                                                                                                );
                                                                                                if (!alreadyExists) {
                                                                                                    return [...current, selectedValue];
                                                                                                }
                                                                                                return current;
                                                                                            } else {
                                                                                                // If unchecking, also remove from primary if it was selected
                                                                                                if (selectedPrimaryResourceList === empEmail) {
                                                                                                    setSelectedPrimaryResourceList(null);
                                                                                                }
                                                                                                return current.filter(
                                                                                                    (item) => item.email !== selectedValue.email
                                                                                                );
                                                                                            }
                                                                                        });
                                                                                    }}
                                                                                />
                                                                                {fullName}
                                                                                <input
                                                                                    title="Select Primary Resource"
                                                                                    className="primaryselector"
                                                                                    type="checkbox"
                                                                                    checked={selectedPrimaryResourceList === empEmail}
                                                                                    disabled={!isAssigned} // Disable if not in assigned list
                                                                                    onChange={() => {
                                                                                        // Only allow selection if the resource is in assigned list
                                                                                        if (isAssigned) {
                                                                                            setSelectedPrimaryResourceList(empEmail);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </label>
                                                                        );
                                                                    })
                                                            ) : (
                                                                <div className="px-2 py-1 text-gray-500">
                                                                    No matching resources found.
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </>
                            )}
                            {assignedPeopleList.length > 0 && (
                                <div className="w-full text-sm max-h-[10rem] overflow-auto">
                                    <div className="flex sticky top-0 bg-[#4e94f8] text-white">
                                        <div className="border flex-1 p-1 flex justify-center align-middle items-center">Employee</div>
                                        <div className="border flex-1 p-1 flex justify-center align-middle items-center">Service Type</div>
                                    </div>
                                    <div className="flex flex-col">
                                        {assignedPeopleList.map((person, index) => {
                                            // Find the matching employee by email
                                            const matchedEmployee = filteredGroupsManager.find(
                                                emp => emp.employeeId?.EmpEmail === person.email
                                            );

                                            const serviceType = matchedEmployee?.employeeId?.servicetype || 'Not assigned';

                                            return (
                                                <div key={index} className="flex border-b">
                                                    <div className="border flex-1 p-1 flex justify-center align-middle items-center">{person.name}</div>
                                                    <div className="border flex-1 p-1 flex justify-center align-middle items-center">{serviceType}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}



                            <div className="pb-4">
                                <label className="text-sm font-medium">
                                    Attachments
                                </label>
                                <WizardFileUpload
                                    setFileNames={setFileNames}
                                    fileNames={fileNames}
                                    SelectedCategory={SelectedCategory}
                                    setSelectedCategory={setSelectedCategory}
                                />
                            </div>
                        </div>
                    )}

                    <div className="flex justify-between mt-4">

                        <div>
                            {step > 1 ? (
                                <button
                                    type="button"
                                    onClick={handlePrev}
                                    className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
                                >
                                    Back
                                </button>
                            ) : (
                                <>
                                </>
                            )}
                        </div>

                        <div>
                            {step < totalSteps ? (
                                <button
                                    type="button"
                                    onClick={handleNext}
                                    className="px-3 py-1.5 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm"
                                >
                                    Next
                                </button>
                            ) : (
                                <button
                                    onClick={(e) => {
                                        handleProjectSubmit(e)
                                    }}
                                    type="submit"
                                    className="px-3 py-1.5 bg-[#e32278] text-white rounded-md text-sm"
                                >
                                    Confirm
                                </button>
                            )}
                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewClient;
